import React from "react";
const VideoCard = ({ videoData }) => {
  console.log(65165, videoData);

  return (
    <div className="vid-box">
      <img src={videoData.video_image} className="img-fluid w-100" alt="" />
      <a href={videoData.video_url} target="_blank" rel="noreferrer">
        <i className="bi bi-play"></i>
      </a>
    </div>
  );
};

export default VideoCard;
